// src/contexts/AreaDataContext.jsx
import { createContext, useContext } from 'react';

export const PropertyGaLoggingContext = createContext(null);

// Optional but recommended: Create a custom hook for using this context
export const usePropertyGaLogging = () => {
  const context = useContext(PropertyGaLoggingContext);
  if (!context) {
    throw new Error('usePropertyGaLogging must be used within an PropertyGaLoggingProvider');
  }
  return context;
};

// Optional but recommended: Create a provider component
export const PropertyGaLoggingProvider = ({ children, value }) => {
  return (
    <PropertyGaLoggingContext.Provider value={value}>
      {children}
    </PropertyGaLoggingContext.Provider>
  );
};